<template>
  <div class="row home-topo">
    <div v-if="banners.length" class="col-lg-7 mb-3">
      <b-carousel
        v-model="slide"
        class="home-banner"
        :interval="5000"
        :controls="banners.length > 1"
        :indicators="banners.length > 1"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd"
      >
        <b-carousel-slide v-for="(banner, index) in banners" :key="index" :caption="banner.descricao">
          <template #img>
            <img class="home-banner-img" :src="'/storage/' + banner.imagem" :alt="banner.descricao" />
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <div :class="banners.length ? 'col-lg-5' : 'col-12'" class="mb-3 home-lateral">
      <!-- avisos com prazo (cashback, bonificacao, kit) vem do Blade pelo slot -->
      <slot></slot>

      <div class="card home-card home-atalhos">
        <div class="home-card-header">
          <span><i class="fas fa-link"></i> Materiais e links úteis</span>
        </div>
        <div class="list-group list-group-flush">
          <a v-if="!pdv" href="/distribuidor/revendedoras_indicadas" class="list-group-item list-group-item-action">
            <i class="fas fa-user-plus"></i> Revendedoras pré-cadastradas
          </a>
          <a
            v-for="(download, index) in downloads"
            :key="'d' + index"
            :href="'/storage/' + download.path"
            target="_blank"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-file-download"></i> {{ download.descricao }}
          </a>
          <a v-if="classe == 'G' && !pdv" href="/distribuidor/devolucao" class="list-group-item list-group-item-action">
            <i class="fas fa-undo-alt"></i> Devolução
          </a>
          <div v-if="pdv && !downloads.length" class="list-group-item text-muted">
            Nenhum material disponível no momento.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      slide: 0,
      sliding: null,
      classe: "",
      pdv: "",
      downloads: [],
    };
  },
  mounted() {
    this.banners = JSON.parse(document.getElementById("banners").value);
    this.classe = document.getElementById("classe").value;
    this.pdv = document.getElementById("pdv").value
      ? document.getElementById("pdv").value
      : "";
    this.downloads = JSON.parse(document.getElementById("downloads").value);
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.home-banner {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  background: #e9ecef;
}
/* banners sao cadastrados em 1080x600 */
.home-banner-img {
  display: block;
  width: 100%;
  aspect-ratio: 1080 / 600;
  object-fit: cover;
}
.home-banner >>> .carousel-caption {
  text-shadow: 1px 1px 2px #333;
}
.home-lateral {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.home-atalhos {
  flex: 1 1 auto;
}
.home-atalhos .list-group-item {
  border-left: 0;
  border-right: 0;
  padding: 10px 16px;
}
.home-atalhos .list-group-item i {
  width: 22px;
  color: #5a7ea6;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/util/CarouselHome.vue